import { AutogenModelEdiDelayCode, AutogenRowEdiDelayCode } from "./autogen/AutogenModelEdiDelayCode";

export class ModelEdiDelayCode extends AutogenModelEdiDelayCode<RowEdiDelayCode> {
	constructor() {
		super(RowEdiDelayCode);
	}
}

export class RowEdiDelayCode extends AutogenRowEdiDelayCode {
}